import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { NAV_PATHS } from '@modules/common/constants';
import { compressToEncodedURIComponent } from 'lz-string';
import { WhereClause } from 'v2/core/services/queryBuilder/whereClause';

export interface GetUseInSearchLinkOptions {
  duration?: DateTimeRange;
  where?: WhereClause | null;
  from?: string;
  to?: string;
  isSearchToFeedEnabled: boolean;
  whereClauseConfig?: {
    whereClause: WhereClause | null;
  } | null;
  prompt?: string;
}

export const getUseInSearchLink = ({
  duration,
  where,
  isSearchToFeedEnabled,
  prompt,
}: GetUseInSearchLinkOptions) => {
  const searchDurationParam = duration
    ? `duration=${encodeURIComponent(JSON.stringify(duration))}`
    : '';

  const searchWhereClauseParam = where
    ? `where=${encodeURIComponent(JSON.stringify(where))}`
    : '';

  const promptParam = prompt ? `prompt=${encodeURIComponent(prompt)}` : '';

  const searchParams = compressToEncodedURIComponent(
    [searchDurationParam, searchWhereClauseParam, promptParam]
      .filter((param) => param.trim().length)
      .join('&'),
  );

  const link = {
    pathname: `/${isSearchToFeedEnabled ? NAV_PATHS.FEED : NAV_PATHS.SEARCH}`,
    search: searchParams,
  };

  return link;
};
